export default "icons-home-inverse"